import React from 'react';
import UnifiedOnboardingModal from '../components/onboarding/UnifiedOnboardingModal';
import { Box } from '@mui/material';
import ApplicationHeader from '../components/ApplicationHeader';
import { useAuth } from '../contexts/AuthContext';

export default function ContractorApplicationPage() {
  const { logout } = useAuth();
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      <ApplicationHeader title="Contractor Application" onLogout={logout} />
      <UnifiedOnboardingModal userRole="contractor" variant="page" />
    </Box>
  );
}
